import LeaveRequest from './views/LeaveRequest.vue';

export default [
  {
    path: '/leaves/request',
    name: 'LeaveRequest',
    meta: { requiresAuth: true, layout: 'dashboard' },
    component: LeaveRequest
  }
];
